export const defaultSiteChromeSettings = {
  topbar_phone: "+91 9732022901",
  topbar_email: "help@nidcs.org",
  topbar_notice: "An ISO 9001:2015 Certified & MSME Certified Organization",
  topbar_notices: ["An ISO 9001:2015 Certified & MSME Certified Organization"],
  topbar_button_text: "",
  topbar_button_link: "/contact",
  footer_eyebrow: "NIDCS",
  footer_heading: "National Institute of Digital Careers and Skills",
  footer_description:
    "Skill development, admissions, centre support, verification, and academic services are presented in a cleaner modern front experience with the same trusted workflow.",
  footer_address: "Bankura, West Bengal",
  footer_phone: "Mob / WhatsApp: +91 9732022901",
  footer_email: "help@nidcs.org",
  facebook_url: "https://facebook.com",
  whatsapp_url: "https://wa.me/919732022901",
  instagram_url: "",
  linkedin_url: "",
  twitter_url: "",
  footer_copyright: "National Institute of Digital Careers and Skills | All Rights Reserved",
};

export function normalizeSiteChromeSettings(value) {
  const source = value && typeof value === "object" ? value : {};
  const next = {
    ...defaultSiteChromeSettings,
    ...source,
  };
  const hasIncomingNoticeArray = Object.prototype.hasOwnProperty.call(source, "topbar_notices");
  const notices = hasIncomingNoticeArray && Array.isArray(next.topbar_notices)
    ? next.topbar_notices.filter(Boolean)
    : String(next.topbar_notice || "")
        .split(/\r\n|\r|\n|\|\|/)
        .map((item) => item.trim())
        .filter(Boolean);
  const normalizedNotices = notices.length ? notices : [next.topbar_notice].filter(Boolean);

  return {
    ...next,
    topbar_notices: normalizedNotices,
    topbar_notice: normalizedNotices.join("\n"),
  };
}
